export default __webpack_public_path__ + "static/media/museum.ef67dec5.JPG";